(() => {
  const scrollLockClass = 'klaviyo-prevent-body-scrolling';
  const popupSelector = '[role="dialog"][aria-label*="POPUP Form"]';
  let unlockTimer;

  const isVisible = (element) => {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number.parseFloat(style.opacity || '1') > 0
      && rect.width > 0
      && rect.height > 0;
  };

  const hasVisibleKlaviyoPopup = () => {
    return [...document.querySelectorAll(popupSelector)].some(isVisible);
  };

  const releaseStaleScrollLock = () => {
    window.clearTimeout(unlockTimer);
    unlockTimer = window.setTimeout(() => {
      if (!document.body.classList.contains(scrollLockClass)) return;
      if (hasVisibleKlaviyoPopup()) return;

      document.body.classList.remove(scrollLockClass);
    }, 500);
  };

  const init = () => {
    releaseStaleScrollLock();

    new MutationObserver((mutations) => {
      const scrollLockChanged = mutations.some((mutation) => {
        return mutation.type === 'attributes'
          && mutation.target === document.body
          && document.body.classList.contains(scrollLockClass);
      });

      if (scrollLockChanged) releaseStaleScrollLock();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
  else {
    init();
  }
})();
